export const UPDATE_ITEM = 'layout/UPDATE_ITEM';
export const DELETE_ITEM = 'layout/DELETE_ITEM';
export const LOAD_LAYOUT = 'layout/LOAD_LAYOUT';
export const ADD_ITEM = 'layout/ADD_ITEM';
export const UPDATE_LAYOUT = 'layout/UPDATE_LAYOUT';
